import { render, staticRenderFns } from "./ApiDialog.vue?vue&type=template&id=668de2ef&scoped=true"
import script from "./ApiDialog.vue?vue&type=script&lang=js"
export * from "./ApiDialog.vue?vue&type=script&lang=js"
import style0 from "./ApiDialog.vue?vue&type=style&index=0&id=668de2ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668de2ef",
  null
  
)

export default component.exports